import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=6618051a&scoped=true&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"
import style0 from "./FeedBack.vue?vue&type=style&index=0&id=6618051a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618051a",
  null
  
)

export default component.exports